const initialState = {
  syncedData: {}
};

// Holds the company-wide ERP coding arrays (jobs, cost codes, GL accounts,
// vendors, phases, terms, reviewers, etc.) fetched once via getSyncedData('all').
// Populated at login and reused across the HIL/canvas screen instead of pulling
// `glInformation` on every get-document-by-id call. Full-replace (not merge) so a
// re-sync or account switch never leaves stale arrays behind.
const SyncedDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'syncedData':
      return {
        ...state,
        syncedData: action.payload
      };
    // Wipe on logout so a different account never reads the previous user's
    // cached arrays (redux-persist keeps this in localStorage, which most
    // logout paths don't clear). Login refetches fresh via load_synced_data.
    case 'clearSyncedData':
      return initialState;
    default:
      return state;
  }
};
export default SyncedDataReducer;
